import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useTrialStaffById = (projectId: string, userId: string) => {
  const p = userId ? ENDPOINTS.TRIAL_STAFF.byTrialStaffId(projectId, userId) : ''
  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
